module.exports = __webpack_public_path__ + "2e25eb313d612acd654594416d916f49.svg";